/*******************************************************
Show Search Box on Devices with Small Screens
Shows the hidden search box on small devices when the search icon button is tapped.
********************************************************/

export default function showMobileSearchBox(e) {

    // Hide the search icon button
    $(e.currentTarget).remove();

    // Show the expanded search box and focus the cursor inside
    $('.top-nav-section__search').addClass('is-visible-mobile').find('input').focus();

    // Add this class to the section bar so we can switch from flex row to column
    $('.section-bar').addClass('search-is-visible');
}
